
class Debug {
    constructor(ident) {
        this.ident = ident || '';
        this.enabled = false;
        this.actions = {}
    }

    setActionsAll(actions) {
        this.actions = actions;
    }

    clearActionsAll() {
        this.actions = {};
    }

    enableActions(actions) {
        for (const action in actions) {
            this.actions[action] = true;
        }
    }

    disableActions(actions) {
        for (const action in actions) {
            this.actions[action] = false;
        }
    }

    info(place, ...args) {
        if (this.enabled && this.actions[place]) {
            console.info(this.ident, ...args);
        }
    }

    log(place, ...args) {
        if (this.enabled && this.actions[place]) {
            console.log(this.ident, ...args);
        }
    }

    warn(place, ...args) {
        if (this.enabled && this.actions[place]) {
            console.warn(this.ident, ...args);
        }
    }

    error(place, ...args) {
        if (this.enabled && this.actions[place]) {
            console.error(this.ident, ...args);
        }
    }
};

export default Debug;
